import React from 'react'
import { Label, Header, Segment, Grid, GridColumn, GridRow, Container, Button } from 'semantic-ui-react'
import Timer from './Timer'
import { connect } from 'react-redux'
import soundUrlAnswGood from '../assets/000003.mp3'
import soundUrlAnswBad from '../assets/000004.mp3'
import ReactPlayer from 'react-player'


const colorRight = 'green';
const colorFalse = 'teal';
const colorBase = 'blue'

//const songPath = '../assets/songs/';
const songPath = 'http://s3.amazonaws.com/cicciolanciabucket/assets/songs/';

class FormMusic extends React.Component {
   
    constructor(props) {
        super(props)
        this.state = {
            answer: '',
            starting_time: null,
            msToAnswer: props.msToAnswer,
            jump:props.jump,
            rightAnswer:props.rightAnswer.toString(),
            isRunning:false,
            isReady:false,
            colorA: colorBase,
            colorB:colorBase,
            colorC:colorBase,
            colorD:colorBase,
            sound:false,
            soundWrong1:false,
            soundWrong2:false,
            soundWrong3:false,
            numberOfMistakes:0,
        }
        this.textInput = null;

        this.setTextInputRef = element => {
          this.textInput = element;
        };
    
        this.focusTextInput = () => {
          // Focus the text input using the raw DOM API
          if (this.textInput) this.textInput.focus();
          if (this.textInput) this.textInput.select();
        };
    }

    componentDidMount() {
        this.focusTextInput();
    }

    onAnswerChange = (e) => this.setState({ answer: e.target.value })

    onSubmit = (e) => {
        e.preventDefault()
        return false
    }

    
    onTimerFinished = () => {
        switch(this.state.rightAnswer){
            case '0':
                this.setState({colorA:colorRight,
                               colorB:colorFalse,
                               colorC:colorFalse,
                               colorD:colorFalse
                });
                break;
            case '1':
                this.setState({colorA:colorFalse,
                    colorB:colorRight,
                    colorC:colorFalse,
                    colorD:colorFalse
                });
                break;
            case '2':
                this.setState({colorA:colorFalse,
                    colorB:colorFalse,
                    colorC:colorRight,
                    colorD:colorFalse
                });
                break;
            case '3':
                this.setState({colorA:colorFalse,
                    colorB:colorFalse,
                    colorC:colorFalse,
                    colorD:colorRight
                });
                break;
            default:
                break;
        }
        this.setState({isRunning:false});
       
    }

    handleInput = (e)  =>{
        if (this.state.isRunning){
            if (e.target.value == this.state.rightAnswer){
                this.setState({msToAnswer:this.state.msToAnswer})
                this.setState({isRunning:false})
                this.setState({sound:true})
                switch(e.target.value){
                    case '0':
                        this.setState({colorA:colorRight,
                                       colorB:colorFalse,
                                       colorC:colorFalse,
                                       colorD:colorFalse
                        });
                        break;
                    case '1':
                        this.setState({colorA:colorFalse,
                            colorB:colorRight,
                            colorC:colorFalse,
                            colorD:colorFalse
                        });
                        break;
                    case '2':
                        this.setState({colorA:colorFalse,
                            colorB:colorFalse,
                            colorC:colorRight,
                            colorD:colorFalse
                        });
                        break;
                    case '3':
                        this.setState({colorA:colorFalse,
                            colorB:colorFalse,
                            colorC:colorFalse,
                            colorD:colorRight
                        });
                        break;
                    default:
                        break;
                }
            } else{
                this.setState({msToAnswer:this.state.msToAnswer-this.state.jump})
                let numbMist = this.state.numberOfMistakes;
                switch(this.state.numberOfMistakes){
                    case 0:
                        this.setState({soundWrong1:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 1:
                        this.setState({soundWrong2:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 2:
                        this.setState({soundWrong3:true, numberOfMistakes:numbMist+1 })
                        break;
                    default:
                        break;
                }
                switch(e.target.value){
                    case '0':
                        this.setState({colorA:colorFalse});
                        break;
                    case '1':
                        this.setState({colorB:colorFalse});
                        break;
                    case '2':
                        this.setState({colorC:colorFalse});
                        break;
                    case '3':
                        this.setState({colorD:colorFalse});
                        break;
                    default:
                        break;
                }
            }
        }
    }

    cleanExtension= (name) =>{
        return new String(name).replace(".mp3", "");
    }

    onStart = () =>{
        this.setState({isRunning:true, isReady:true});
        this.setState({ starting_time: Date.now() })
    }

    render() {
        const {msToAnswer,colorA,colorB,colorC,colorD, sound, soundWrong1,soundWrong2,soundWrong3, isRunning,isReady} = this.state
        const {songA, songB,songC,songD,rightAnswer} = this.props
        if (!isRunning && isReady) setTimeout(this.props.onGameEnded,2000);
        let rightSong = null;
        switch (rightAnswer){
            case 0:
                rightSong = songA;
                break;
            case 1:
                rightSong = songB;
                break;
            case 2:
                rightSong = songC;
                break;
            case 3:
                rightSong = songD;
                break;
        }

        let songUrl = songPath+""+rightSong;
        return (
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{"Canzone"}</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Header as='h2' style={{ fontWeight: 'normal' }}>{'CHE CANZONE È QUESTA?'}</Header>
                        {sound?<audio ref="audio_tag" src={soundUrlAnswGood} autoPlay/>:""}
                        {soundWrong1?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {soundWrong2?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {soundWrong3?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        <Grid centered celled>
                        <GridColumn centered width={16}>
                               <Container textAlign='center'>
                               <ReactPlayer  url={songUrl} playing={isRunning} controls={true} onStart={this.onStart}/>
                               </Container>
                            </GridColumn>
                        <GridRow >
                        </GridRow>
                            <GridRow >
                               <GridColumn centered width={8}>
                               <Container textAlign='center'>
                               <Button fluid  color={colorA} value='0' onClick={this.handleInput}>
                                    {this.cleanExtension(songA)}
                                </Button>
                                </Container>
                               </GridColumn>
                               <GridColumn centered width={8}>
                               <Button fluid  color={colorB} value='1' onClick={this.handleInput}>
                               {this.cleanExtension(songB)}
                               </Button>
                                </GridColumn>
                            </GridRow>
                            <GridRow >
                               <GridColumn centered  width={8}>
                               <Button fluid  color={colorC} value='2' onClick={this.handleInput}>
                               {this.cleanExtension(songC)}
                               </Button>
                               </GridColumn>
                               <GridColumn centered width={8}>
                               <Button fluid  color={colorD} value='3' onClick={this.handleInput}>
                               {this.cleanExtension(songD)}
                               </Button>
                                </GridColumn>
                            </GridRow>
                        </Grid>
                        <Timer  ms={msToAnswer} bar={false} isRunning={isRunning} isReady={isReady} handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished} />
                    </div>
                    <Timer  ms={msToAnswer} isRunning={isRunning} isReady={isReady} bar={true}  handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished} />
                </Segment>
        )
    }

}

const mapStateToProps = (state, { isLogged }) => ({
    state : state, 
    user: state.user,
    isLogged,
    songA:state.game?state.game.songA:undefined,
    songB:state.game?state.game.songB:undefined,
    songC:state.game?state.game.songC:undefined,
    songD:state.game?state.game.songD:undefined,
    rightAnswer:state.game?state.game.rightAnswer:undefined,
})

const mapDispatchToProps = (dispatch, { socket }) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormMusic)


// WEBPACK FOOTER //
// ./src/components/FormMusic.js